import { Card, CardBrandTypeEnum } from 'app/services/responseTypes';
import {
  AmericanExpressIcon,
  CartesBancairesIcon,
  CreditCardGenericIcon,
  DiscoverIcon,
  JcbcardIcon,
  MastercardIcon,
  StarFillIcon,
  StarIcon,
  UnionpayIcon,
  VisaIcon,
} from 'assets/icons';
import DeleteButton from 'Components/Buttons/DeleteButton';

export interface ICreditCardProps {
  card: Card;
  onDelete: () => any;
  setDefault: () => any;
  defaultCardId: string;
}

interface ICardIcons {
  [key: string]: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
}

const CardIcons: ICardIcons = {
  [CardBrandTypeEnum.visa]: VisaIcon,
  [CardBrandTypeEnum.mastercard]: MastercardIcon,
  [CardBrandTypeEnum.unionpay]: UnionpayIcon,
  [CardBrandTypeEnum.jcb]: JcbcardIcon,
  [CardBrandTypeEnum.discover]: DiscoverIcon,
  [CardBrandTypeEnum.cartes_bancaires]: CartesBancairesIcon,
  [CardBrandTypeEnum.amex]: AmericanExpressIcon,
};

const CardIcon = ({ type }: { type: CardBrandTypeEnum }) => {
  const Icon = CardIcons[type] || CreditCardGenericIcon;
  return <Icon />;
};

export default function CreditCard({
  card,
  onDelete,
  setDefault,
  defaultCardId,
}: ICreditCardProps) {
  return (
    <div
      key={card.id}
      style={{ maxWidth: '384px' }}
      className={
        ' px-2 bg-gray-light-10 w-full h-16 rounded-xl flex justify-between items-center md-max:grid md-max:h-28'
      }
    >
      <div className="inline-flex gap-8">
        <div>
          <CardIcon type={card.brand} />
        </div>
        <div className="grid text-xs">
          <span className="inline-flex gap-2  md-max:grid  ">
            <p className=" text-gray-dark font-extrabold">
              **** **** **** {card.last_4_digits}
            </p>
            {defaultCardId === card.id && (
              <p className="text-gray-light">(Default)</p>
            )}
          </span>
          <span className="text-gray-light">
            EXP {card.exp_month}/{card.exp_year}
          </span>
        </div>
      </div>
      <div className=" inline-flex gap-2 md-max:justify-center">
        <div
          className="cursor-pointer border border-green rounded-lg hover:shadow-lg w-10 h-8 grid "
          onClick={setDefault()}
        >
          {card.id === defaultCardId ? (
            <StarFillIcon className="place-self-center" />
          ) : (
            <StarIcon className="place-self-center text-green" />
          )}
        </div>
        <div>
          <DeleteButton onClick={onDelete()} />
        </div>
      </div>
    </div>
  );
}
